import { render, staticRenderFns } from "./helloworld2.vue?vue&type=template&id=13b0d91e"
import script from "./helloworld2.vue?vue&type=script&lang=js"
export * from "./helloworld2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports